import type { ReactNode } from "react";
import { Icon } from "@/components/icon/icon";
import { Button } from "@/components/ui/button";
import { ICON_KEYS } from "@/icons/icon-registry";
import { cn } from "@/utils/class-name";

type FormVariant = "create" | "edit" | "delete";

const variantBg: Record<FormVariant, string> = {
    create: "bg-primary/20",
    edit: "bg-info/20",
    delete: "bg-destructive/20",
};

interface FormContainerProps {
    title: string;
    onClose: () => void;
    variant: FormVariant;
    children: ReactNode;
}

/**
 * Simple container for the on-demand irrigation forms
 */
export function FormContainer({ title, onClose, variant, children }: FormContainerProps) {
    return (
        <div className={cn("p-4 rounded-md gap-6 flex flex-col", variantBg[variant])}>
            <div className={"flex flex-row justify-between items-center"}>
                <h2 className={"text-xl font-medium"}>{title}</h2>
                <Button variant={"ghost"} size={"icon"} onClick={onClose}>
                    <Icon icon={ICON_KEYS.CLOSE} />
                </Button>
            </div>
            {children}
        </div>
    );
}
